import {
  Button, CircularProgress,
  Dialog, DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useCallback } from "react";

interface TagsDialogComponentProps {
  onClose: (e: any) => void;
  open: boolean;
  onToggleVisibility: (e: boolean) => void;
  tags: any[];
}
export const TagsDialog = ({ onClose, open, onToggleVisibility, tags}: TagsDialogComponentProps) => {
  return (
    <div id={'view-tags'}>
      <Dialog
        maxWidth={'lg'}
        onClose={(e) => onClose(e)}
        open={open}
        PaperProps={{ style: { zIndex: 1000 } }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Tags
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={(e) => onToggleVisibility(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell align="right">Value</TableCell>
                </TableRow>
              </TableHead>
              {/* eslint-disable-next-line react/jsx-no-undef */}
              <TableBody>
                {tags?.map((row: { id: string; tagName: string }) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="right">{row.id}</TableCell>
                    <TableCell align="right">{row.tagName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button disabled={false} autoFocus onClick={(e) => {}}>
            {<CircularProgress size={6} />}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
